import React, { useEffect } from 'react'
import classNames from 'classnames'
import { Helmet } from 'react-helmet'
import { sendEvent } from 'cityads-v3/utils/htmlUtils'
import { useSelector } from 'react-redux'

import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import classes from './Article.scss'
import { RootState } from 'cityads-v3/types/reducer'

type ArticleProps = React.PropsWithChildren<{
  title: string
  inPopup?: boolean
  pageTitle: string
  pageDescription: string
  pageKeywords: string
  isMobile?: boolean
}>

export default function Article({
  title, inPopup, pageTitle, pageDescription, pageKeywords, children, ...rest
}: ArticleProps) {
  const isMobile = useSelector((state: RootState) => state.app.isMobile)

  useEffect(() => {
    setTimeout(() => {
      window && sendEvent(window, 'resize')
    })
  })

  const content = (
    <article className={classNames(classes.article, { [classes.popupArticle]: inPopup })} {...rest}>
      {(title && !inPopup) ? (
        <h1 className={classes.header}>{title}</h1>
      ) : false}

      {(pageTitle || pageDescription || pageKeywords) ?
        (
          <Helmet
            title={pageTitle}
            meta={[
              ...(pageDescription ? [{ name: 'description', content: pageDescription }] : []),
              ...(pageKeywords ? [{ name: 'keywords', content: pageKeywords }] : []),
            ]}
          />
        ) :
        null
      }

      <div className={classes.text}>
        {children}
      </div>
    </article>
  )

  if (inPopup) {
    return [
      <DialogTitle
        key="title"
        sx={{
          fontSize: isMobile ? '1.25em' : '2em',
          padding: isMobile ? '20px 52px 8px 24px' : '64px 32px 24px',
          maxWidth: '576px',
          margin: '0 auto',
          fontWeight: '400',
          lineHeight: '1.3',
          boxSizing: 'content-box',
        }}
      >
        {title}
      </DialogTitle>,
      <DialogContent
        key="content"
      >
        {content}
      </DialogContent>
    ] as unknown as JSX.Element
  } else {
    return content
  }
}
